<template>
  <div>
    <div class="m-wrapper" style="margin-top:18px;border-radius:0px;">
      <div class="titleBox">
          <span class="bigTitleInfo">Total Investment Ranking</span>
          <span class="chenge-dir">Statistics in {{merchants.merchantsLut.year}}<br>The following data is for reference only</span>
      </div>
      <div class="splitLine"></div>

      <div class="chart-top clearfix">
        <div class="title">Total FDI</div>
        <div class="unit">Unit: billion USD</div>
      </div>

      <ChartBar
        :title="'Total FDI'"
        :unit="'billion USD'"
        :width="'100%'"
        :height="'350px'"
        :id="'cy'"
        :keyName="'ftzName'"
        :keyCount="'fgnInvest'"
        :option="merchants.merchantsList"
        :barColor="'#FDAE59'"
        :barBorderColor="'#FDAE59'"
        :data-zoom-flag="true"
      />
    </div>
<!-- 
    <FtaBottomDateInfo
      info="Investment & cooperation display data until"
      :date="merchants.merchantsLut"
    /> -->
<div class="splitLine"></div>
    <div class="m-wrapper" style="border-radius:0px;">
      <div class="titleBox">
          <span class="bigTitleInfo">Project Details</span>
      </div>
      <div class="splitLine"></div>

      <div class="filter-wrapper">
        <div class="filter-content">
          <div class="filter clearfix">
            <div class="item" style="width: 100%">
              <div class="inner-wrapper">
                <div style="width: 115px" class="label">Project search</div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="form.ippName"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                    @change="ippNameChange"
                  >
                    <el-option
                      v-for="item in ippNameDdb"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 24px;" class="filter clearfix">
            <div class="item">
              <div class="inner-wrapper">
                <div style="width: 115px" class="label">Project location</div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="form.region"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                    @change="regionChange"
                  >
                    <el-option
                      v-for="item in regionDdb"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="inner-wrapper">
                <div style="width: 140px; text-align: right;padding-right: 10px" class="label">Investment amount</div>
                <div class="form-wrapper">
                  <div class="form">
                    <el-select
                      filterable
                      v-model="moneyVal"
                      style="width: 100%"
                      popper-class="select-down"
                      size="small"
                      :popper-append-to-body="false"
                      @change="handleMoneyChange"
                    >
                      <el-option
                        v-for="item in moneyOption"
                        :key="item.id"
                        :label="item.val"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <!--                  form.oneInvestAmount-->
                  <!--                  form.twoInvestAmount-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-confirm">
          <div class="confirm-button" @click="getQueryByPage">Go</div>
        </div>
      </div>
      <div style="margin-top: 24px;" class="center">
        <div class="list"  v-if="tableData.length!==0">
          <div class="item clearfix" v-for="(item,index) in tableData" :key="item.ippName" @click="handleListItemIconClick(index)">
            <div class="left">
              <div class="content">
                NO.{{ index + 1 }}
              </div>
            </div>
            <div class="right">
              <div class="top clearfix">
                <div class="date">{{ item.ippTime }}</div>
                <div class="title fontBold">{{ item.ippName }}</div>
              </div>
              <div class="tips">
                <div class="item">{{ item.inds }}</div>
                <div class="item">{{ item.region }}</div>
                <div class="item">{{ item.investAmount }}(million USD)</div>
                <div class="item" v-if="item.engSrc">{{ item.engSrc }}</div>
              </div>

              <template v-if="!item.close">
                <div class="info">
                  <div class="item">
                    <span class="fontBold">Entity:</span>
                    <span>{{ item.mainBody }}</span>
                  </div>
                  <div class="item">
                    <span class="fontBold">Validation:</span>
                    <span>{{ item.validity }}</span>
                  </div>
                  <div class="item">
                    <span class="fontBold">Investment Method:</span>
                    <span>{{ item.investType }}</span>
                  </div>
                </div>
                <div style="margin-bottom: 18px" class="text">
                  <div class="title fontBold">Project Details:</div>
                  <div style="font-size: 12px;">
                    {{ item.detailInfo }}
                  </div>
                </div>
                <div class="text" v-if="item.contactUnit && item.contactPerson && item.contactInfo">
                  <div class="title fontBold">Contact:</div>
                  <div class="detail" v-if="item.contactUnit">
                    <span>Contact agency：{{ item.contactUnit }}</span>
                  </div>
                  <div class="detail" v-if="item.contactPerson">
                    <span>Contacts：{{ item.contactPerson }}</span>
                  </div>
                  <div class="detail" v-if="item.contactInfo">
                    <span>Phone：{{ item.contactInfo }}</span>
                  </div>
                </div>
              </template>
            </div>

            <div class="icon">
              <img :src="closeIcon" alt="" v-if="item.close">
              <img :src="openIcon" alt="" v-else>
            </div>
          </div>
        </div>
        <template v-else>
          <div style="text-align: center">No Data</div>
        </template>
        <div class="list-pagination">
          <div class="list-pagination-wrapper">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="pageConfig.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageConfig.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="pageConfig.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FtaHeader from '../component/FtaHeader'
import request from '../../../ftaUtils/http'
import baseUrl from '../../../ftaUtils/baseUrl'
import FtaTable from '../component/FtaTable'
import ChartBar from '../component/ChartBar'
import ChartLine from '../component/ChartLine'
import ChartPie from '../component/ChartPie'
import FtaTitle from '../component/FtaTitle'
import FtaBottomDateInfo from '../component/FtaBottomDateInfo'
import {getCookieKey} from '../../../ftaUtils/util'

export default {
  name: 'InvestmentShow',
  components: {
    FtaBottomDateInfo,
    FtaTitle,
    FtaHeader,
    FtaTable,
    ChartBar,
    ChartLine,
    ChartPie
  },
  data () {
    return {
      openIcon: require('../../../assets/images/fta/icon11.png'),
      closeIcon: require('../../../assets/images/fta/icon10.png'),

      // 项目名称
      ippNameDdb: [],
      // 项目所属区域
      regionDdb: [],
      // 投资金额
      moneyVal: '',
      moneyOption: [
        {'id': 'all', 'val': 'all'},
        {'id': '1', 'val': 'less than 1 million'},
        {'id': '2', 'val': '1 million-5 million'},
        {'id': '3', 'val': '5 million-10 million'},
        {'id': '4', 'val': 'More than 10 million'}
      ],

      merchants: {
        merchantsLut:{
          year:'',
          month:''
        }
      },

      form: {
        twoInvestAmount: '',
        oneInvestAmount: '',
        region: '',
        ippName: ''
      },
      pageConfig: {
        // total: 10000,
        page: 1,
        pageSize: 10
      },
      tableData: [],
    }
  },
  methods: {
    regionChange () {
      this.pageConfig.page = 1
      this.pageConfig.pageSize = 10
    },
    ippNameChange () {
      this.pageConfig.page = 1
      this.pageConfig.pageSize = 10
    },
    handleMoneyChange (val) {
      this.pageConfig.page = 1
      this.pageConfig.pageSize = 10
      switch (val) {
        // 全部
        case '':
          this.form.oneInvestAmount = ''
          this.form.twoInvestAmount = ''
          break
        // 小于100万
        case '1':
          this.form.oneInvestAmount = '0'
          this.form.twoInvestAmount = '100'
          break
        // 100万-500万
        case '2':
          this.form.oneInvestAmount = '100'
          this.form.twoInvestAmount = '500'
          break
        // 500万-1000万
        case '3':
          this.form.oneInvestAmount = '500'
          this.form.twoInvestAmount = '1000'
          break
        // 1000万以上
        case '4':
          this.form.oneInvestAmount = '1000'
          this.form.twoInvestAmount = ''
          break
      }
    },
    handleCurrentChange (page) {
      this.pageConfig.page = page
      this.getQueryByPage()
    },
    handleListItemIconClick (index) {
      this.tableData[index].close = !this.tableData[index].close
    },
    getQueryDdbInfo () {
      request('get', `${baseUrl.base_1}/merchantsCooperation/queryDdbInfo`).then((res) => {
        const {regionDdb, ippNameDdb} = res.data
        this.regionDdb = regionDdb
        this.ippNameDdb = ippNameDdb
        this.regionDdb.unshift({val: 'all', id: 'all'})
        this.ippNameDdb.unshift({val: 'all', id: 'all'})
      })
    },
    getQueryByPage () {
      let {page, pageSize} = this.pageConfig
      let formData = this.form

       formData.ippName = formData.ippName == 'all' ? '' : formData.ippName
       formData.region = formData.region == 'all' ? '' : formData.region 

      request('get', `${baseUrl.base_1}/merchantsCooperation/queryByPage`, {
        limit: pageSize, page: page, ...formData
      }).then((res) => {
        res.data.records.forEach(item => {
          item.close = true
        })

        this.tableData = res.data.records
        this.pageConfig.total = res.data.total
        this.pageConfig.pageSize = res.data.size
        this.pageConfig.page = res.data.current
      })
    },
    getQueryFgnInvestTop () {
      request('get',`${baseUrl.base_1}/merchantsCooperation/queryFgnInvestTop`).then((res) => {
        this.merchants = res.data
      })
    },
    changeTableData () {
      this.getQueryByPage()
    }
  },
  created () {
    const TS02b1f2d3 = getCookieKey('TS02b1f2d3')
    this.$store.commit('ftaToken', TS02b1f2d3)
    
    this.getQueryDdbInfo()
    this.getQueryByPage()
    this.getQueryFgnInvestTop()
  },
  // watch: {
  //   pageConfig: {
  //     handler () {
  //       this.getQueryByPage()
  //     },
  //     deep: true
  //   }
  // }
}
</script>
<style src="../fta.css"  scoped></style>
<style lang="less"  src="./InvestmentShow.less"  scoped></style>

